/** Shared primitive types used across sim, state, and scenes. */

/** Integer tile coordinate on the map grid. */
export interface TileXY {
  x: number;
  y: number;
}

/** A pixel/world-space position. */
export interface Vec2 {
  x: number;
  y: number;
}

export type Direction = 'up' | 'down' | 'left' | 'right';

/** Stable string key for a tile, for use in Sets/Maps. */
export const tileKey = (x: number, y: number): string => `${x},${y}`;

export const parseTileKey = (key: string): TileXY => {
  const parts = key.split(',');
  return { x: Number(parts[0]) || 0, y: Number(parts[1]) || 0 };
};
